import request, { merchantApi } from '@/config/axios'

// ==================== 玄学机构入驻（平台端审核，同师傅入驻模式） ====================

/** 审核状态：0=待审核 1=通过 2=驳回 3=已撤销（真源在 merchant_apply 主申请） */
export const INSTITUTION_AUDIT_STATUS_OPTIONS = [
  { label: '待审核', value: 0 },
  { label: '已通过', value: 1 },
  { label: '已驳回', value: 2 },
  { label: '已撤销', value: 3 }
]

export const INSTITUTION_AUDIT_STATUS_LABELS: Record<number, string> = {
  0: '待审核',
  1: '已通过',
  2: '已驳回',
  3: '已撤销'
}

export const INSTITUTION_AUDIT_STATUS_TAG_TYPES: Record<number, string> = {
  0: 'warning',
  1: 'success',
  2: 'danger',
  3: 'info'
}

/** 分页筛选参数 */
export interface InstitutionApplyPageParams {
  pageNo: number
  pageSize: number
  auditStatus?: number
  companyName?: string
  nickname?: string
  mobile?: string
}

/** 机构入驻申请（扩展单 + merchant 主申请合并视图） */
export interface InstitutionApplyVo {
  id: number
  applyId: number
  memberId: number
  memberNickname?: string
  mobile?: string
  companyName: string
  creditCode?: string
  businessLicense?: string
  legalPerson?: string
  idCardFront?: string
  idCardBack?: string
  city?: string
  years?: number
  intro?: string
  qualificationUrls?: string[]
  contactMobile?: string
  loginUsername?: string
  auditStatus: number
  auditRemark?: string
  auditTime?: string
  createTime?: string
}

/** 审核参数（applyId = merchant_apply.id；驳回时 remark 必填） */
export interface InstitutionApplyAuditParams {
  applyId: number
  approved: boolean
  remark?: string
}

export const InstitutionApplyApi = {
  // 查询机构入驻申请分页（审核状态/机构名称模糊/昵称模糊/手机号精确）
  getApplyPage: (params: InstitutionApplyPageParams) => {
    return request.get({ url: '/xuanxue/institution-apply/page', params })
  },
  // 审核机构入驻申请（通过自动建店/主账号/机构档案并开通玄学机构台）
  auditApply: (data: InstitutionApplyAuditParams) => {
    return request.put({ url: '/xuanxue/institution-apply/audit', data })
  }
}

// ==================== 机构旗下师傅（挂靠关系） ====================

/** 挂靠状态：0=待机构确认 1=已挂靠 2=机构拒绝 3=师傅退出 4=机构解聘 */
export const AFFILIATION_STATUS_OPTIONS = [
  { label: '待确认', value: 0 },
  { label: '已挂靠', value: 1 },
  { label: '已拒绝', value: 2 },
  { label: '师傅退出', value: 3 },
  { label: '机构解聘', value: 4 }
]

export const AFFILIATION_STATUS_LABELS: Record<number, string> = {
  0: '待确认',
  1: '已挂靠',
  2: '已拒绝',
  3: '师傅退出',
  4: '机构解聘'
}

export const AFFILIATION_STATUS_TAG_TYPES: Record<number, string> = {
  0: 'warning',
  1: 'success',
  2: 'danger',
  3: 'info',
  4: 'danger'
}

/** 挂靠关系分页筛选 */
export interface AffiliationPageParams {
  pageNo: number
  pageSize: number
  /** 商户端不传（后端按登录机构过滤）；平台端可传机构名称模糊 institutionName */
  institutionName?: string
  masterName?: string
  status?: number
}

/** 挂靠关系行 */
export interface AffiliationVo {
  id: number
  masterId: number
  masterName?: string
  sealChar?: string
  category?: string
  years?: number
  institutionId: number
  institutionName?: string
  status: number
  applyRemark?: string
  auditRemark?: string
  joinTime?: string
  exitTime?: string
  exitReason?: string
  createTime?: string
}

export const AffiliationApi = {
  // 商户端：本机构挂靠关系分页（controller.merchant 包 → /merchant-api 前缀，走 merchantApi 身份；后端按登录机构过滤）
  getPage: (params: AffiliationPageParams) => {
    return merchantApi.get({ url: '/merchant-api/xuanxue/institution/affiliation/page', params })
  },
  // 商户端：审核挂靠申请（同意→生效；拒绝需填原因）
  audit: (data: { id: number; approved: boolean; remark?: string }) => {
    return merchantApi.put({ url: '/merchant-api/xuanxue/institution/affiliation/audit', data })
  },
  // 商户端：解聘已挂靠师傅（原因必填）
  dismiss: (data: { id: number; reason: string }) => {
    return merchantApi.put({ url: '/merchant-api/xuanxue/institution/affiliation/dismiss', data })
  }
}

// ==================== 平台端：机构旗下师傅（仅查询） ====================

export const InstitutionAffiliationAdminApi = {
  // 平台端：挂靠关系分页（机构名称/师傅姓名模糊 + 状态筛选）
  getPage: (params: AffiliationPageParams) => {
    return request.get({ url: '/xuanxue/institution-affiliation/page', params })
  }
}
